import { useTranslation } from 'react-i18next'
import { IEvaluationResume } from 'models/evaluation.model'
import Detail from './detail'
import { Wrapper, Title, Description, Container, Subtitle } from './styled'

interface IProps {
  id: number
  name: string
  description: string
  showEvaluation: (evaluation: IEvaluationResume) => void
}

export const ContentEvaluation = ({
  id,
  name,
  description,
  showEvaluation,
}: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluationBlock.detail'

  return (
    <Wrapper>
      <Title>{name}</Title>
      {description && <Description>{description}</Description>}
      <Container>
        <Subtitle>{t(`${translationPrefix}.title`)}</Subtitle>
        <Detail evaluationId={id} onShowEvaluation={showEvaluation} />
      </Container>
    </Wrapper>
  )
}
